import React from 'react';

import OrganizationSwitch from 'components/SessionSwitches/OrganizationSwitch';
import RoleSwitch from 'components/SessionSwitches/RoleSwitch';
import LanguageSwitch from 'components/LanguageSwitch';
import NotificationDropdown from 'components/GeneralMessaging/NotificationDropdown';
import SupportSwitch from 'components/SupportSwitch';

import jwt from 'utils/jwt';

const HeaderMenu: React.FC<any> = ({
    selectedOrganization,
    customerOptions,
    organizationOptions,
    setSelectedOrganizationType,
    setSelectedOrganization,
    roles,
    setSelectedUserTypeId,
    session,
    environment,
    switchToStudentRole,
    switchToAdministrationEnvironment,
    clearSession,
    isMobile,
    closeDrawer
}) => {
    return (
        <>
            <OrganizationSwitch
                selectedOrganization={selectedOrganization}
                customers={customerOptions}
                organizations={organizationOptions}
                isMobile={isMobile}
                onClick={(value: number, type: any) => {
                    setSelectedOrganizationType(type);
                    setSelectedOrganization(value)
                }}
            />

            <RoleSwitch
                roles={roles}
                isMobile={isMobile}
                onClick={(value: number) => setSelectedUserTypeId(value)}
                selectedUserTypeId={session.active_user_type_id}
                usersName={`${session.name} ${session.surname}`}
            />

            <LanguageSwitch
                isMobile={isMobile}
            />
            <NotificationDropdown
                isMobile={isMobile}
            />
            {/*{environment === 'ADMINISTRATION'*/}
            {/*    ? <NavLink to='/'><i className='fal fa-book header-item' onClick={() => switchToStudentRole()}/></NavLink>*/}
            {/*    : (!(['STUDENT', 'LECTOR'].includes(session.active_user_type)) ?*/}
            {/*        <NavLink to='/'><i className='fal fa-user-cog header-item' onClick={() => switchToAdministrationEnvironment()}/></NavLink> : null)*/}
            {/*}*/}
            {/* TODO */}
            {/* Kamēr nav funkcionalitāte tikmēr nerādīt */}
            {/*{<i className='fal fa-bell header-item' /><i className='fal fa-cog header-item' />}*/}

            <SupportSwitch
                isMobile={isMobile}
                type={session.active_user_type}
                closeDrawer={closeDrawer}
            />

            {
                isMobile ?
                    <div className='session-switch-item-mobile'>
                        <div className='role-switch' onClick={() => {
                            jwt.logout(session.logout);
                            clearSession()
                        }}>
                            <span>Logout<i className='fal fa-sign-out header-item'/></span>
                        </div>
                    </div>
                :
                    <i className='fal fa-sign-out header-item' onClick={() => {
                        jwt.logout(session.logout);
                        clearSession()
                    }}/>
            }
        </>
    )
};
export default HeaderMenu;
